import messageBus from '@/core/message-bus'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import store from '@/store'
import { translate, formatPrice, formatPriceWithoutCurrency } from '@/core/localization'
import httpService from '@/core/http-service'
import { sharedText } from '../core/utils'

const mixin = {
  props: {
    blockId: { type: String, required: false },
    cssClasses: {
      type: [String, Array, Object],
      default: null
    }
  },
  computed: {
    ...mapGetters(['breakpoints', 'isPortrait', 'clientModel']),
    closestBlockId() {
      return this.blockId || _.get(this, '$parent.closestBlockId')
    }
  },
  data: () => ({
    subscriptions: []
  }),
  methods: {
    subscribe(key, callback) {
      messageBus.subscribe(key, callback)
      this.subscriptions.push({ key, callback })
    },
    publish() {
      messageBus.publish(...arguments)
    },
    mq(key) {
      return this.breakpoints[key]
    },
    mqIsPortrait() {
      return this.isPortrait
    },
    t(key) {
      return translate(key, this.closestBlockId)
    },
    tStatic(key) {
      return sharedText(key)
    },
    isEndpointActive(endpoint) {
      return _.some(store.getters['ui/activeEndpoints'], config => _.endsWith(config.url, endpoint))
    },
    getProductFewInStock() {
      const threshold = parseInt(store.getters.clientModel.thresholdFewStock, 10)

      if(!threshold) {
        return 0
      }
      return threshold
    },
    getProductListPageSize(defaultPageSize) {
      const pageSize = store.getters.clientModel.productPageSize

      if(!pageSize) {
        return defaultPageSize
      }

      return pageSize
    },
    get(...args) {
      return _.get(...args)
    },
    getAssetPath(src) {
      const assetsPath = '@/assets'
      if(_.startsWith(src, assetsPath)) {
        return require('@/assets' + src.substr(assetsPath.length, src.length))
      }

      if(process.env.VUE_APP_TYPE === 'spa') {
        const test = (_.startsWith(src, 'https://')) ? src : (process.env.VUE_APP_IMAGE_BASE_URL || '') + src
        return test
      }

      return src
    },
    formatPrice,
    formatPriceWithoutCurrency,
    async signOut() {
      await store.dispatch('checkout/clearCheckout')
      await store.dispatch('myMachines/setGlobalMyMachinesSelection', {})
      await sessionStorage.removeItem('userDetailsModalClosed')
      const response = await httpService.get('auth/signout')
      window.location = response.data.url
    }
  },
  beforeDestroy() {
    _.forEach(this.subscriptions, subscription => {
      messageBus.unsubscribe(subscription.key, subscription.callback)
    })
  }
}

export default mixin
